<template>
  <form
    id="applicationSubmission"
    @submit.prevent="handleSubmit"
  >
    <div class="grid-container">
      <div class="grid-y grid-margin-x">
        <h2><b>{{ $t("message.resultsTitle") }}</b></h2>
        <!-- <h3>{{ $t("message.resultsResultsLabel") }}</h3> -->
        <div>
          {{ $t("message.secondResultsDescription") }}
          <p>{{ $t("message.secondResultsDescription2") }}</p>

          <p v-html="$t('message.secondResultsDescription3')" />
          <ul>
            <li
              style="margin-left: 2rem;"
              v-html="$t('message.applyToThisProgram')"
            />
            <!-- <li>{{ $t("message.iWantToBeContacted") }}</li> -->
            <li 
              style="margin-left: 2rem;"
              v-html="$t('message.websiteOrPhoneNumberListed')"
            />
          </ul>
          <!-- Horizontal Line inputed here, may cause issues in mobile version may need to move this to the CSS style below and place it in a class -->
          <hr style="height: 30px; width: 100%; margin-top: 1%; margin-bottom: 1%;">
          <br>
          <!-- Available Programs Label -->
          <div v-if="hasVisibleShiaPrograms">
            <!-- <h3><b>{{ $t('message.shiaProgramsLabel') }}</b></h3> -->
          </div>
          <h2
            v-if="hasVisibleShiaPrograms"
          >
            <b>{{ $t('message.availableProgramsLabel') }}</b>
          </h2>
        </div>

        <!-- SHIA PROGRAMS (grouped together in one box, one shared Apply button) -->
        <div
          v-if="hasVisibleShiaPrograms"
          class="shia-programs-box"
        >
          <div
            v-for="(program, idx) in shiaPrograms"
            :key="'shia-' + idx"
          >
            <div v-if="program.isVisible">
              <ul>
                <li>
                  <label style="color: #0f4d90;">{{ program.name }}:</label>
                  <span> {{ $t(program.description) }}</span>
                  <span v-if="program.phoneNumber"> &#8226; {{ program.phoneNumber }}</span>
                  <span v-if="program.website"> &#8226; <a
                    :href="program.website"
                    target="_blank"
                  >{{ $t("message.websiteLabel") }}</a></span>
                </li>
              </ul>
            </div>
          </div>
          <a
            :href="encryptedLinkPath"
            target="_blank"
            class="button"
          >
            {{ $t("message.secondWebsiteLabel") }}
          </a>
        </div>

        <!-- REST OF THE PROGRAMS (grouped together below the SHIA programs as individual cards) -->
        <div v-if="hasVisibleOtherPrograms">
          <h2>
            {{ $t('message.contactProgramDirectlyLabel') }}
          </h2>
          <div class="contact-program-grid">
            <div
              v-for="(program, idx) in otherPrograms"
              :key="'other-' + idx"
            >
              <div
                v-if="program.isVisible"
                class="contact-program-card"
              >
                <h3><b>{{ program.name }}</b></h3>
                <p>{{ $t(program.description) }}</p>
                <hr>
                <p
                  v-if="program.phoneNumber"
                  style="color: #0f4d90;"
                >
                  <b>{{ program.phoneNumber }}</b>
                </p>
                <a
                  v-if="program.website"
                  :href="program.website"
                  target="_blank"
                  class="contact-program-link"
                >{{ $t("message.websiteLabel") }}</a>
              </div>
            </div>
          </div>
        </div>

        <!-- <div
          v-if="resultsValid == true && $v.applicantInterestedList.$invalid"
          class="love-park-red"
        >
          {{ $t("message.resultsSelectProgram") }}
        </div> -->
        <div v-if="resultsValid == false">
          <b>{{ $t("message.resultsNoQualifications")
          }} <a href="./">{{ $t("message.resultsReturnToHomepage") }}</a></b>
        </div>
        <br>
                
        <div class="cell">
          <h4
            v-if="submitStatus === 'OK'"
            class="typo__p"
          >
            {{ $t("message.resultsSubmissionThanks") }}
          </h4>
          <h4
            v-if="submitStatus === 'PENDING'"
            class="loader"
          >
            {{ $t("message.resultsSubmitting") }}
            <span class="loader__dot">.</span>
            <span class="loader__dot">.</span>
            <span class="loader__dot">.</span>
          </h4>
          <h4 v-if="submitStatus === 'POST_ERROR'">
            {{ $t("message.resultsSubmissionError") }}
          </h4>
        </div>
        <!-- <div class="grid-x grid-padding-x align-right">
          <div class="cell medium-4">
            <button
              :disabled="submitStatus === 'PENDING' || submitStatus === 'OK'"
              class="button"
            >
              {{ $t("message.resultsContactButton") }}
            </button>
          </div>
        </div> -->
      </div>
    </div>
  </form>
</template>

<script>
// import {
//   buildApplicationDataObject,
//   dataObjectToXml,
// } from "../utilities/functions";
// import axios from "axios";
import { required } from 'vuelidate/lib/validators';
import { map } from 'lodash';

// Programs with an active SHIA application link
const SHIA_PROGRAMS = [
  'Adaptive Modifications Program',
  'Basic Systems Repair Program',
  'Built to Last',
  'Heater Hotline',
  'Restore Repair Renew Loan Program',
  'Weatherization Assistance Program',
  'Disaster Recovery & Resilience Program',
];

export default {
  name: "Third",
  props: {
    adultsPath: { type: String, default: null },
    childPath: { type: String, default: null },
    incomePath: { type: String, default: null },
    yearsPath: { type: String, default: null },
    disabilityPath: { type: String, default: null },
    primaryResidencePath: { type: String, default: null },
    homeownerPath: { type: String, default: null },
    spropertyPath: { type: String, default: null },
    deedPath: { type: String, default: null },
    referralPath: { type: String, default: null },
    employeePath: { type: String, default: null },
    roofLeakPath: { type: String, default: null },
    electricProblemPath: { type: String, default: null },
    plumbingProblemPath: { type: String, default: null },
    structuralProblemPath: { type: String, default: null },
    floorStairsPath: { type: String, default: null },
    heaterOrHotWaterPath: { type: String, default: null },
    helpInHomePath: { type: String, default: null },
    tangleTitlePath: { type: String, default: null },
    solarPowerPath: { type: String, default: null },
    billProblemPath: { type: String, default: null },
    shiaEmailPath: { type: String, default: null },
    encryptedLinkPath: { type: String, default: null },
    drrpDocsPath: { type: String, default: null },
  },
  data() {
    return {
      submitStatus: null,
      Name: null,
      EmailAddress: null,
      Address: {
        Street1: null,
        Street2: null,
        City: null,
        State: null,
        Zip: null,
      },
      Phone: null,
      resultsValid: false,
      // TripleRSelection: null,
      programs: [
        {
          // If you comment out website, the website will show undefined through the email link.
          id: 1,
          name: "Adaptive Modifications Program", //complete
          applicantInterested: false,
          phoneNumber: "215-448-2160",
          description: "message.amodDescription",
          website: "https://phdcphila.org/residents/home-repair/adaptive-modifications-program/",
          //this is where the new SHIA website will be pasted
          links: this.encryptedLinkPath,
          isVisible: false,
        },
        {
          id: 2,
          name: "Basic Systems Repair Program", //complete
          applicantInterested: false,
          phoneNumber: "215-448-2160",
          description: "message.bsrpDescription",
          website: "https://phdcphila.org/residents/home-repair/basic-systems-repair-program/",
          //this is where the new SHIA website will be pasted
          links: this.encryptedLinkPath,
          isVisible: false,
        },
        {
          id: 3,
          name: "Built to Last",
          applicantInterested: false,
          phoneNumber: "215-686-4483",
          description: "message.builtToLastDescription",
          website: "https://philaenergy.org/programs-initiatives/built-to-last/",
          //this is where the new SHIA website will be pasted
          links: this.encryptedLinkPath,
          isVisible: false,
    
        },
        {
          id: 4,
          name: "Heater Hotline", //complete
          applicantInterested: false,
          phoneNumber: "215-568-7190",
          description: "message.heaterDescription",
          website: "https://www.ecasavesenergy.org/heater-hotline",
          //this is where the new SHIA website will be pasted
          links: this.encryptedLinkPath,
          isVisible: false,
        },
        {
          id: 5, //complete
          name: "Housing Counseling",
          applicantInterested: false,
          phoneNumber: "215-686-9749",
          description: "message.housingCounselingDescription",
          website: "https://www.phila.gov/departments/division-of-housing-and-community-development/neighborhood-resources/housing-counseling/",
          isVisible: false,
                
        },
        {
          id: 6,
          name: "Neighborhood Energy Centers",
          applicantInterested: false,
          description: "message.necDescription",
          website: "https://www.phila.gov/departments/division-of-housing-and-community-development/neighborhood-resources/neighborhood-energy-centers-necs/",
          isVisible: false,
        },
        {
          id: 7,
          name: "PEA-Solarize Philly Program",
          applicantInterested: false,
          phoneNumber: "215-686-4483",
          description: "message.solarPowerDescription",
          website: "https://solarizephilly.org/",
          isVisible: false,
        },
        {
          id: 8,
          name: "Philly First Home", //complete
          applicantInterested: false,
          phoneNumber: "215-686-9749",
          description: "message.pfhDescription",
          website: "https://phdcphila.org/residents/homebuyers-and-renters/philly-first-home/",
          isVisible: false,
        },
        {
          id: 9,
          name: "Restore Repair Renew Loan Program", //complete
          applicantInterested: false,
          phoneNumber: "Call Clarifi (215-866-5200) to begin the intake process. ", //awilliams@philapcca.org, rrr@clarifi.org
          description: "message.tripleRDescription",
          website: "https://phdcphila.org/rrr/",
          links: this.encryptedLinkPath,
          isVisible: false,
        },
        {
          id: 10,
          name: "Tangled Title", //complete
          applicantInterested: false,
          phoneNumber: "215-523-9564", //reverify phone
          description: "message.tangledTitleDescription", //old description: Grants to assist low-income residents gain clear legal title to their home.
          website: "https://philalegal.org/services/save-your-home-philly-hotline", 
          isVisible: false,
        },
        {
          id: 11,
          name: "Turn the Key", //complete
          applicantInterested: false,
          phoneNumber: "215-448-3000",
          description: "message.turnTheKeyDescription",
          website: "https://phdcphila.org/residents-and-landlords/homebuyers-and-renters/turn-the-key/",
          isVisible: false,
        },
        {
          id: 12,
          name: "Utility Grant Program", //complete
          applicantInterested: false,
          phoneNumber: "215-972-5170",
          description: "message.utilityGrantDescription",
          website: "https://uesfacts.org/our-programs/utility-grant-program/",
          isVisible: false,
        },
        {
          id: 13,
          name: "Weatherization Assistance Program",
          applicantInterested: false,
          phoneNumber: "1-866-466-3972",
          description: "message.wapDescription",
          website: "https://dced.pa.gov/programs/weatherization-assistance-program-wap/",
          //this is where the new SHIA website will be pasted/ waiting on WAP to be ready
          links: this.encryptedLinkPath,
          isVisible: false,
        },
        {
          id: 14,
          name: "Longtime Owner Occupants Program",
          applicantInterested: false,
          phoneNumber: "215-686-9200",
          description: "message.loopDescription",
          website: "https://www.phila.gov/services/payments-assistance-taxes/payment-plans-and-assistance-programs/income-based-programs-for-residents/apply-for-the-longtime-owner-occupants-program-loop/",
          isVisible: false,
        },
        {
          id: 15,
          name: "Homestead Exemption Application",
          applicantInterested: false,
          phoneNumber: "215-686-8686",
          description: "message.homesteadDescription",
          website: "https://www.phila.gov/documents/homestead-exemption-application/",
          isVisible: false,
        },
        {
          id: 16,
          name: "Disaster Recovery & Resilience Program",
          applicantInterested: false,
          phoneNumber: "215-448-2160",
          description: "message.drrpdDescription",
          website: "https://phdcphila.org/disaster-recovery-and-resilience-program-drrp/",
          links: this.encryptedLinkPath,
          isVisible: false,
        },
        {
          id: 17,
          name: "One Philly Mortgage",
          applicantInterested: false,
          description: "message.onePhillyMortgageDescription",
          website: "https://phdcphila.org/one-philly-mortgage-program/",
          //links: this.encryptedLinkPath,
          isVisible: false,
        },
        {
          id: 18,
          name: "Curbside Appeal Program",
          applicantInterested: false,
          description: "message.curbsideAppealDescription",
          website: "https://www.phila.gov/programs/curbside-appeal-program/",
          //links: this.encryptedLinkPath,
          isVisible: false,
        },
        {
          id: 19,
          name: "Wills Program",
          applicantInterested: false,
          description: "message.willDescription",
          website: "https://www.phila.gov/programs/wills-program/",
          //links: this.encryptedLinkPath,
          isVisible: false,
        },
        {
          id: 20,
          name: "Facade Improvement Program",
          applicantInterested: false,
          description: "message.facadeImprovementDescription",
          website: "https://phdcphila.org/facade-improvement-program/",
          //links: this.encryptedLinkPath,
          isVisible: false,
        },
      ],
    };
  },
  validations: {
    Name: { required },
    EmailAddress: { required },
    Address: {
      Street1: { required },
      City: { required },
      State: { required },
      Zip: { required },
    },
    Phone: { required },
    applicantInterestedList: { required }, //, minLength: 1
  },

  computed: {
    // SHIA programs (grouped together in one box with a shared Apply button)
    shiaPrograms() {
      return this.programs.filter(p => SHIA_PROGRAMS.includes(p.name));
    },
    hasVisibleShiaPrograms() {
      return this.shiaPrograms.some(p => p.isVisible);
    },
    // Remaining programs (grouped together below the SHIA programs)
    otherPrograms() {
      return this.programs.filter(p => !SHIA_PROGRAMS.includes(p.name));
    },
    hasVisibleOtherPrograms() {
      return this.otherPrograms.some(p => p.isVisible);
    },
    applicantInterestedList() {
      return this.programs
        .filter(program => program.applicantInterested)
        .map(program => program.name)
        .join(";");
    },

    debugProgramNames() {
      return this.programs.map(p => ({
        name: p.name,
        isVisible: p.isVisible,
        matchesInclude: SHIA_PROGRAMS.includes(p.name),
      }));
    },
  },

  created(){
    this.checkForAMP(this.childPath, this.adultsPath, this.incomePath);
    this.checkForBSRP(this.childPath, this.adultsPath, this.incomePath);
    this.checkForBTL(this.childPath, this.adultsPath, this.incomePath);
    this.checkForDRRP(this.childPath, this.adultsPath, this.incomePath);
    this.checkForHH(this.childPath, this.adultsPath, this.incomePath);
    this.checkForHC();
    this.checkForNEC(this.childPath, this.adultsPath, this.incomePath);
    this.checkForPEA();
    this.checkForPFH(this.childPath, this.adultsPath, this.incomePath);
    this.checkForRRR(this.childPath, this.adultsPath, this.incomePath);
    this.checkForTT(this.childPath, this.adultsPath, this.incomePath);
    this.checkForTK(this.childPath, this.adultsPath, this.incomePath);
    this.checkForUG(this.childPath, this.adultsPath, this.incomePath);
    this.checkForWAP(this.childPath, this.adultsPath, this.incomePath);
    this.checkForLOOP();
    this.checkForHEA();
    this.checkForOPM();
    this.checkForCAP();
    this.checkForWP();
    this.checkForFIP();
  },
  
  methods: {
    //C,A,I Children, Adults, Income Questions
    calcNec(c, a, i) {
      if (parseInt(c) + parseInt(a) == 1 && i <= 66850) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 2 && i <= 76400) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 3 && i <= 85950) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 4 && i <= 95500) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 5 && i <= 103150) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 6 && i <= 110800) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 7 && i <= 118450) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 8 && i <= 126100) {
        return true;
      }
      if (
        parseInt(c) + parseInt(a) > 8 &&
        i <= 126100 + 7650 * (parseInt(c) + parseInt(a) - 8)
      ) {
        return true;
      }
      return false;
    },

    calcAmp(c, a, i) {
      // Adaptive Modifications Program 2026 Income Guidelines
      if (parseInt(c) + parseInt(a) == 1 && i <= 68750) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 2 && i <= 78550) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 3 && i <= 88350) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 4 && i <= 98150) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 5 && i <= 106050) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 6 && i <= 113900) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 7 && i <= 121750) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 8 && i <= 129600) {
        return true;
      }
      if (
        parseInt(c) + parseInt(a) > 8 &&
        i <= 129600 + 7850 * (parseInt(c) + parseInt(a) - 8)
      ) {
        return true;
      }
      return false;
    },

    calcBSRP(c, a, i) {
      // Basic Systems Repair Program 2026 Income Guidelines
      if (parseInt(c) + parseInt(a) == 1 && i <= 85900) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 2 && i <= 98200) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 3 && i <= 110500) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 4 && i <= 122700) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 5 && i <= 132600) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 6 && i <= 142400) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 7 && i <= 152200) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 8 && i <= 162000) {
        return true;
      }
      if (
        parseInt(c) + parseInt(a) > 8 &&
        i <= 162000 + 9800 * (parseInt(c) + parseInt(a) - 8)
      ) {
        return true;
      }
      return false;
    },

    calcBTL(c, a, i) {
      // Built to Last 2026 Income Guidelines (60% AMI)
      if (parseInt(c) + parseInt(a) == 1 && i <= 51540) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 2 && i <= 58920) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 3 && i <= 66300) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 4 && i <= 73620) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 5 && i <= 79560) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 6 && i <= 85440) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 7 && i <= 91320) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 8 && i <= 97200) {
        return true;
      }
      return false;
    },

    calcRenew(c, a, i) {
    //Used to calculate eligibility for restore, repair, renew
      if (parseInt(c) + parseInt(a) == 1 && i <= 100300) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 2 && i <= 114650) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 3 && i <= 129000) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 4 && i <= 143300) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 5 && i <= 154750) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 6 && i <= 166250) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 7 && i <= 177700) {
        return true;
      }
      if (parseInt(c) + parseInt(a) >= 8 && i <= 189150) {
        return true;
      }
      if (
        parseInt(c) + parseInt(a) > 8 &&
        i <= 189150 + 11500 * (parseInt(c) + parseInt(a) - 8)
      ) {
        return true;
      }
      return false;
    },

    calcAMI(c, a, i, multipler) {
      if (parseInt(c) + parseInt(a) == 1 && i <= 83600 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 2 && i <= 95550 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 3 && i <= 107500 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 4 && i <= 119400 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 5 && i <= 129000 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 6 && i <= 138550 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 7 && i <= 148100 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 8 && i <= 157650 * multipler) {
        return true;
      }
      if (
        parseInt(c) + parseInt(a) > 8 &&
        i <= (157650 * multipler) + (9550 * multipler) * (parseInt(c) + parseInt(a) - 8)
      ) {
        return true;
      }
      return false;
    },

    fedPovertyCalc(c, a, i, multipler) {
      //Used to calculate eligibility for programs that base income off of federal poverty guidelines, with a multiplier for income. https://aspe.hhs.gov/poverty-guidelines
      if (parseInt(c) + parseInt(a) == 1 && i <= 15960 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 2 && i <= 21640 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 3 && i <= 27320 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 4 && i <= 33000 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 5 && i <= 38680 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 6 && i <= 44360 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 7 && i <= 50040 * multipler) {
        return true;
      }
      if (parseInt(c) + parseInt(a) == 8 && i <= 55720 * multipler) {
        return true;
      }
      if (
        parseInt(c) + parseInt(a) > 8 &&
        i <= (55720 * multipler) + (5680 * multipler) * (parseInt(c) + parseInt(a) - 8)
      ) {
        return true;
      }
      return false;
    },
    // Adaptive Modifications Program 2026 Income Guidelines
    checkForAMP(c,a,i) {
      const ampProgram = this.programs.find(p => p.name === "Adaptive Modifications Program");
      if (!ampProgram) {
        return;
      }
      if (
        this.primaryResidencePath === "Yes" &&
        this.disabilityPath === "Yes" &&
        this.spropertyPath === "No" &&
        this.calcAmp(c, a, i)
      ) {
        if (
          (this.homeownerPath === "Homeowner" &&
          this.deedPath === "Deed" &&
          this.helpInHomePath !== "No") ||
          (this.homeownerPath === "Renter" &&
          this.deedPath === "Lease" &&
          parseInt(this.yearsPath) >= 3 &&
          this.helpInHomePath !== "No")
        ) {
          this.resultsValid = true;
          ampProgram.isVisible = true;
        } else {
          ampProgram.isVisible = false;  
        }
      } else {
        ampProgram.isVisible = false;
      }
    },

    checkForDRRP(c,a,i) {
      const drrpProgram = this.programs.find(p => p.name === "Disaster Recovery & Resilience Program");
      if (!drrpProgram) {
        return;
      }
      const userInterestedInDrrp = this.drrpDocsPath === "Yes";
      if (
        this.primaryResidencePath === "Yes" &&
        this.spropertyPath === "No" &&
        this.calcAMI(c, a, i, 0.8) &&
        userInterestedInDrrp
      ) {
        if (
          this.homeownerPath === "Homeowner" &&
          this.deedPath === "Deed" &&
          this.helpInHomePath !== "No"
        ) {
          this.resultsValid = true;
          drrpProgram.isVisible = true;
        } else if (
          this.homeownerPath === "Renter" &&
          this.deedPath === "Lease" &&
          parseInt(this.yearsPath) >= 3 &&
          this.helpInHomePath !== "No"
        ) {
          this.resultsValid = true;
          drrpProgram.isVisible = true;
        } else {
          drrpProgram.isVisible = true;
        }
      } else {
        drrpProgram.isVisible = false;
      }
    },

    // Basic Systems Repair Program 2026 Income Guidelines
    checkForBSRP(c,a,i) {
      const bsrpProgram = this.programs.find(p => p.name === "Basic Systems Repair Program");
      const btlProgram = this.programs.find(p => p.name === "Built to Last");
      if (!bsrpProgram || !btlProgram) {
        return;
      }
      if(
        this.primaryResidencePath === "Yes" &&
        this.calcBSRP(c, a, i) === true &&
        this.spropertyPath === "No" &&
        this.deedPath === "Deed" &&
        this.homeownerPath === "Homeowner" &&
        this.heaterOrHotWaterPath === "No"
      ) {
        let tryCount = 0;
        const results = [
          this.roofLeakPath,
          this.plumbingProblemPath,
          this.structuralProblemPath,
          this.electricProblemPath,
          this.floorStairsPath,
        ];
        for (const result of results) {
          if (result !== "No") {
            tryCount++;
          }
        }
        if (tryCount >= 1) {
          this.resultsValid = true;
          bsrpProgram.isVisible = true;
        }
      } else {
        bsrpProgram.isVisible = false;
      }
    },

    checkForHH(c,a,i) {
      const hhProgram = this.programs.find(p => p.name === "Heater Hotline");
      const btlProgram = this.programs.find(p => p.name === "Built to Last");
      if (!hhProgram || !btlProgram) {
        return;
      }
      if (btlProgram.isVisible === true) {
        hhProgram.isVisible = false;
        return false;
      } else if (
        this.primaryResidencePath === "Yes" &&
        this.spropertyPath === "No" &&
        this.deedPath === "Deed" &&
        this.homeownerPath === "Homeowner" &&
        this.fedPovertyCalc(c, a, i, 1.5) === true
      ) { 
        if (this.heaterOrHotWaterPath !== "No") {
          this.resultsValid = true;
          hhProgram.isVisible = true;
        }
      } else if (this.heaterOrHotWaterPath === "No") {
        hhProgram.isVisible = false;
      }
    },

    // checkForWAP(c,a,i) {
    //   const wapProgram = this.programs.find(p => p.name === "Weatherization Assistance Program");
    //   const btlProgram = this.programs.find(p => p.name === "Built to Last");
    //   if (!wapProgram || !btlProgram) {
    //     return;
    //   }
    //   if (btlProgram.isVisible === true) {
    //     wapProgram.isVisible = false;
    //     return false;
    //   } else if (
    //     this.primaryResidencePath === "Yes" &&
    //     this.homeownerPath === "Homeowner" &&
    //     this.fedPovertyCalc(c, a, i, 2) &&
    //     this.billProblemPath !== "No"
    //   ) {
    //     this.resultsValid = true;
    //     wapProgram.isVisible = true;
    //   } else {
    //     wapProgram.isVisible = false;
    //   }
    // },

    checkForPFH(c,a,i) {
      const pfhProgram = this.programs.find(p => p.name === "Philly First Home");
      if (!pfhProgram) {
        return;
      }
      if (
        this.calcAMI(c, a, i, 1) === true &&
        this.homeownerPath !== "Homeowner" &&
        this.deedPath !== "Deed" &&
        this.spropertyPath === "No"
      ) {
        this.resultsValid = true;
        pfhProgram.isVisible = true;
      } else {
        pfhProgram.isVisible = false;
      }
    },

    checkForHC() {
      const hcProgram = this.programs.find(p => p.name === "Housing Counseling");
      if (!hcProgram) {
        return;
      }
      if (this.primaryResidencePath === "Yes") {
        this.resultsValid = true;
        hcProgram.isVisible = true;
      } else {
        hcProgram.isVisible = false;
      }
    },

    checkForTT(c,a,i) {
      const ttProgram = this.programs.find(p => p.name === "Tangled Title");
      if (!ttProgram) {
        return;
      }
      if (
        this.primaryResidencePath === "Yes" &&
        this.calcAMI(c, a, i, 0.8) === true &&
        this.deedPath === "Neither" &&
        this.tangleTitlePath === "Yes"
      ) {
        this.resultsValid = true;
        ttProgram.isVisible = true;
      } else {
        ttProgram.isVisible = false;
      }
    },

    checkForRRR(c,a,i) {
      const rrrProgram = this.programs.find(p => p.name === "Restore Repair Renew Loan Program");
      if (!rrrProgram) {
        return;
      }
      if (
        this.primaryResidencePath === "Yes" &&
        this.calcRenew(c, a, i) === true &&
        this.homeownerPath === "Homeowner" &&
        this.deedPath === "Deed"
      ) {
        this.resultsValid = true;
        rrrProgram.isVisible = true;
      } else {
        rrrProgram.isVisible = false;
      }
    },

    checkForUG(c,a,i) {
      const ugProgram = this.programs.find(p => p.name === "Utility Grant Program");
      if (!ugProgram) {
        return;
      }
      if (
        this.primaryResidencePath === "Yes" &&
        this.fedPovertyCalc(c, a, i, 1.75) === true
      ) {
        this.resultsValid = true;
        ugProgram.isVisible = true;
      } else {
        ugProgram.isVisible = false;
      }
    },

    checkForTK(c,a,i) {
      const tkProgram = this.programs.find(p => p.name === "Turn the Key");
      if (!tkProgram) {
        return;
      }
      if (
        this.homeownerPath !== "Homeowner" &&
        this.deedPath !== "Deed" &&
        parseInt(this.yearsPath) >= 3 &&
        this.employeePath === "Yes" &&
        this.calcAMI(c, a, i, 1) === true
      ) {
        this.resultsValid = true;
        tkProgram.isVisible = true;
      } else {
        tkProgram.isVisible = false;
      }
    },

    checkForPEA() {
      const peaProgram = this.programs.find(p => p.name === "PEA-Solarize Philly Program");
      if (!peaProgram) {
        return;
      }
      if (
        this.primaryResidencePath === "Yes" &&
        this.homeownerPath === "Homeowner" &&
        this.spropertyPath === "No"
      ) {
        if (this.solarPowerPath !== "No") {
          this.resultsValid = true;
          peaProgram.isVisible = true;
        }
      } else if (this.solarPowerPath === "No") {
        peaProgram.isVisible = false;
      }
    },

    // Built to Last 2026 Income Guidelines
    checkForBTL(c,a,i) {
      const btlProgram = this.programs.find(p => p.name === "Built to Last");
      if (!btlProgram) {
        return;
      }

      if (
        this.primaryResidencePath === "Yes" &&
        this.homeownerPath === "Homeowner" &&
        this.spropertyPath === "No" &&
        this.calcBTL(c, a, i) === true
      ) {
        const repairs = [
          this.roofLeakPath,
          this.plumbingProblemPath,
          this.structuralProblemPath,
          this.electricProblemPath,
          this.floorStairsPath,
        ];
        if (repairs.some(r => r !== "No")) {
          btlProgram.isVisible = true;
          this.resultsValid = true;
        } else {
          btlProgram.isVisible = false;
        }
      } else {
        btlProgram.isVisible = false;
      }
    },

    checkForNEC(c,a,i) {
      const necProgram = this.programs.find(p => p.name === "Neighborhood Energy Centers");
      if (!necProgram) {
        return;
      }
      if (
        this.primaryResidencePath == "Yes" &&
        this.homeownerPath == "Homeowner" || this.homeownerPath == "Renter" &&
        this.calcNec(c, a, i) == true &&
        this.billProblemPath !== "No"
      ) {
        this.resultsValid = true;
        necProgram.isVisible = true;
      } else {
        necProgram.isVisible = false;
      }
    },

    checkForLOOP() {
      const loopProgram = this.programs.find(p => p.name === "Longtime Owner Occupants Program");
      if (this.homeownerPath === "Homeowner" && loopProgram) {
        this.resultsValid = true;
        loopProgram.isVisible = true;
      } else if (loopProgram) {
        loopProgram.isVisible = false;
      }
    },

    checkForHEA() {
      const heaProgram = this.programs.find(p => p.name === "Homestead Exemption Application");
      if (this.homeownerPath === "Homeowner" && heaProgram) {
        this.resultsValid = true;
        heaProgram.isVisible = true;
      } else if (heaProgram) {
        heaProgram.isVisible = false;
      }
    },

    checkForOPM() {
      const opmProgram = this.programs.find(p => p.name === "One Philly Mortgage");
      if (!opmProgram) {
        return;
      }
      opmProgram.isVisible = true;
    },

    checkForCAP() {
      const capProgram = this.programs.find(p => p.name === "Curbside Appeal Program");
      if (!capProgram) {
        return;
      }
      capProgram.isVisible = true;
    },

    checkForWP() {
      const wpProgram = this.programs.find(p => p.name === "Wills Program");
      if (!wpProgram) {
        return;
      }
      wpProgram.isVisible = true;
    },

    checkForFIP() {
      const fipProgram = this.programs.find(p => p.name === "Facade Improvement Program");
      if (!fipProgram) {
        return;
      }
      fipProgram.isVisible = true;
    },

    checkEligibility(
      name,
      primaryResidencePath,
      c,
      a,
      i,
      disabilityPath,
      homeownerPath,
      spropertyPath,
      deedPath,
      yearsPath,
      employeePath,
      roofLeakPath,
      electricProblemPath,
      plumbingProblemPath,
      structuralProblemPath,
      floorStairsPath,
      heaterOrHotWaterPath,
      helpInHomePath,
      tangleTitlePath,
      solarPowerPath,
      billProblemPath,
      shiaEmailPath,
    ) {
      this.checkForNEC(c,a,i);
      this.checkForBTL(c,a,i);
      this.checkForDRRP(c,a,i);
      this.checkForHH(c,a,i);
      this.checkForPFH(c,a,i);
      this.checkForRRR(c,a,i);
      this.checkForTT(c,a,i);
      this.checkForTK(c,a,i);
      this.checkForUG(c,a,i);
      this.checkForWAP(c,a,i);
      this.checkForBSRP(c,a,i);
      this.checkForAMP(c,a,i);
      this.checkForHC();
      this.checkForPEA();
      this.checkForLOOP();
      this.checkForHEA();
      this.checkForOPM();
      this.checkForCAP();
      this.checkForWP();
      this.checkForFIP();

      if (
        name == null &&
        primaryResidencePath == null &&
        c == null &&
        a == null &&
        i == null &&
        disabilityPath == null &&
        homeownerPath == null &&
        spropertyPath == null &&
        deedPath == null &&
        yearsPath == null &&
        employeePath == null &&
        roofLeakPath == null &&
        electricProblemPath == null &&
        plumbingProblemPath == null &&
        structuralProblemPath == null &&
        floorStairsPath == null &&
        heaterOrHotWaterPath == null &&
        helpInHomePath == null &&
        tangleTitlePath == null &&
        solarPowerPath == null &&
        billProblemPath == null &&
        shiaEmailPath == null
      ) {
        this.resultsValid = false;
        return false;
      }
    }, 

    handleSubmit() {
      var vData = this;
      if (this.$v.$invalid == true) {
        this.submitStatus = "ERROR";
      }

      const selectedPrograms = this.programs
        .filter(program => program.applicantInterested)
        .map(program => ({
          id: program.id,
          name: program.name,
          website: program.website,
          links: program.links,
          phoneNumber: program.phoneNumber,
          description: program.description,
          applicantInterested: program.applicantInterested }));
      if (selectedPrograms.length === 0) {
        alert("Please select at least one program.");
        return;
      }
      this.$v.$touch();
      this.submitStatus = "OK";
      this.$router.push({
        name: "Results",
        params: { selectedPrograms,
          adultsPath: this.adultsPath,
          childPath: this.childPath,
          incomePath: this.incomePath,
          yearsPath: this.yearsPath,
          disabilityPath: this.disabilityPath,
          primaryResidencePath: this.primaryResidencePath,
          homeownerPath: this.homeownerPath,
          spropertyPath: this.spropertyPath,
          deedPath: this.deedPath,
          referralPath: this.referralPath,
          employeePath: this.employeePath,
          roofLeakPath: this.roofLeakPath,
          electricProblemPath: this.electricProblemPath,
          plumbingProblemPath: this.plumbingProblemPath,
          structuralProblemPath: this.structuralProblemPath,
          floorStairsPath: this.floorStairsPath,
          heaterOrHotWaterPath: this.heaterOrHotWaterPath,
          helpInHomePath: this.helpInHomePath,
          tangleTitlePath: this.tangleTitlePath,
          solarPowerPath: this.solarPowerPath,
          billProblemPath: this.billProblemPath,
          drrpDocsPath: this.drrpDocsPath,
        },
      },
      )
        .catch(() => {
          vData.submitStatus = "POST_ERROR";
        });
    },
  },
};
</script>

<style scoped>
#applicationSubmission {
  margin-top: 80px;
  padding: 0 5%;
}

h2 {
  color: #0f4d90;
  font-size: 1.75rem;
  margin-bottom: 1rem;
  word-break: break-word;
  availableProgramsLabel {
    font-size: 1.25rem;
  }
}

@media only screen and (max-width: 767px) {
  h2 {
    font-size: 1.25rem;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1023px) {
  h2 {
    font-size: 1.5rem;
  }
}

.shia-programs-box {
  border: 4px solid #0f4d90;
  border-radius: 14px;
  padding: 1rem;
  margin-bottom: 4rem;
}

.contact-program-label {
  color: #333;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.contact-program-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.contact-program-card {
  border: 1px solid #d8d8d8;
  border-radius: 12px;
  padding: 1.5rem;
  background: #fff;
  height: 100%;
  box-sizing: border-box;
}

.contact-program-card h3 {
  color: #0f4d90;
  font-size: 1.15rem;
  margin: 0 0 0.75rem;
}

.contact-program-card p {
  color: #444;
  margin: 0 0 1rem;
}

.contact-program-card hr {
  border: none;
  border-top: 1px solid #e2e2e2;
  margin: 0 0 1rem;
}

.contact-program-link {
  font-weight: 700;
  text-decoration: underline;
  color: #0f4d90;
}
</style>